import { z } from 'zod';

import { WorkerTypeWithAll } from './-constants';

export const PeopleCertificationTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // タブフィルタ
  workerType: z.nativeEnum(WorkerTypeWithAll).default(WorkerTypeWithAll.ALL),
  // フィルタ
  freeText: z.string().optional(),
});
